import React from 'react';
import DatePicker from 'react-datepicker';
import MultiDatePicker, { DateObject } from 'react-multi-date-picker';
import Select from 'react-select';
import {
  NotifyUsersToFillTheFormPeriodOptions,
  NotifyUsersToFillTheFormStopType,
  NotifyUsersToFillTheFormTimeOptions,
  NotifyUsersToFillTheFormStopPeriod,
  NotifyUsersToFillTheFormStopFrequency,
  timeOptions,
  notificationOptions,
} from '../../../../constants/forms/options';
import DateCalendar from '../../../calendars/DateCalendar/DateCalendar';

const NotifyUsersSettings = ({
  handelSettings,
  notification_settings,
  errors,
  title = 'Remind users to fill out the form',
  notificationTextPlaceholder = 'Enter notification or message text that will be sent to users  who were assigned as form submitters',
}) => {
  const handleSelectWeekDays = (weekDay) => {
    if (notification_settings.notify_users_to_fill_the_form_sending_week_days) {
      if (!notification_settings.notify_users_to_fill_the_form_sending_week_days.includes(weekDay)) {
        handelSettings(
          [...notification_settings.notify_users_to_fill_the_form_sending_week_days, weekDay],
          'notify_users_to_fill_the_form_sending_week_days',
        );
      } else {
        handelSettings(
          notification_settings.notify_users_to_fill_the_form_sending_week_days.filter((item) => item !== weekDay),
          'notify_users_to_fill_the_form_sending_week_days',
        );
      }
    }
  };

  return (
    <div className="form-control-item-settings">
      <div className="form-settings-label">
        <label className="form-label form-label-big">{title}</label>
      </div>
      <div className="form-settings-inputs">
        <div className="d-flex">
          <div className={`form-control-radio`}>
            <input
              name="should_notify_users_to_fill_the_form"
              type="radio"
              value="true"
              onChange={() => handelSettings(true, 'should_notify_users_to_fill_the_form')}
              checked={notification_settings.should_notify_users_to_fill_the_form}
            />
            <span>Yes</span>
          </div>
          <div className={`form-control-radio`}>
            <input
              name="should_notify_users_to_fill_the_form"
              type="radio"
              value="false"
              onChange={() => handelSettings(false, 'should_notify_users_to_fill_the_form')}
              checked={notification_settings.should_notify_users_to_fill_the_form === false}
            />
            <span>No</span>
          </div>
        </div>
        {notification_settings.should_notify_users_to_fill_the_form && (
          <>
            <div className="form-control-item-group">
              <label className="form-label">Notification type</label>
              <div className="select-multy-wrapper">
                <Select
                  hideSelectedOptions={false}
                  isSearchable={false}
                  isDisabled
                  options={notificationOptions}
                  value={notification_settings.notify_users_to_fill_the_form_notification_type}
                  onChange={(e) => handelSettings(e, 'notify_users_to_fill_the_form_notification_type')}
                  className="form-control-select"
                  placeholder="Sms / Email"
                  classNamePrefix="react-select"
                ></Select>
              </div>
              <span className="form-error">
                {errors?.notify_users_to_fill_the_form_notification_type &&
                  errors.notify_users_to_fill_the_form_notification_type[0]}
              </span>
            </div>
            <div className="form-control-item-group">
              <label className="form-label">Notification text</label>
              <textarea
                onChange={(e) => handelSettings(e.target.value, 'notify_users_to_fill_the_form_notification_text')}
                value={notification_settings.notify_users_to_fill_the_form_notification_text}
                placeholder={notificationTextPlaceholder}
                className="form-control"
              ></textarea>
              <span className="form-error">
                {errors?.notify_users_to_fill_the_form_notification_text &&
                  errors.notify_users_to_fill_the_form_notification_text[0]}
              </span>
            </div>
            <div className="form-control-item-group">
              <label className="form-label">Repeat every</label>
              <div className="d-flex gap-3">
                <div className="form-control-item-half">
                  <Select
                    hideSelectedOptions={false}
                    isSearchable={false}
                    options={NotifyUsersToFillTheFormTimeOptions}
                    value={notification_settings.notify_users_to_fill_the_form_repeat}
                    onChange={(e) => handelSettings(e, 'notify_users_to_fill_the_form_repeat')}
                    className="form-control-select"
                    placeholder="Select quantity"
                    classNamePrefix="react-select"
                  ></Select>
                  <span className="form-error">
                    {errors?.notify_users_to_fill_the_form_repeat && errors.notify_users_to_fill_the_form_repeat[0]}
                  </span>
                </div>

                <div className="form-control-item-half">
                  <Select
                    hideSelectedOptions={false}
                    isSearchable={false}
                    options={NotifyUsersToFillTheFormPeriodOptions}
                    value={notification_settings.notify_users_to_fill_the_form_period}
                    onChange={(e) => handelSettings(e, 'notify_users_to_fill_the_form_period')}
                    className="form-control-select"
                    placeholder="Period"
                    classNamePrefix="react-select"
                  ></Select>
                  <span className="form-error">
                    {errors?.notify_users_to_fill_the_form_period && errors.notify_users_to_fill_the_form_period[0]}
                  </span>
                </div>
              </div>
            </div>

            {notification_settings.notify_users_to_fill_the_form_period?.value == 'weekly' && (
              <div className={'form-item mb-6'}>
                <label htmlFor="">Send on these days:</label>
                <div className={'week-grid'}>
                  <div className={'form-control-checkbox-span'}>
                    <input
                      type="checkbox"
                      checked={notification_settings.notify_users_to_fill_the_form_sending_week_days?.includes(0)}
                      onChange={(e) => handleSelectWeekDays(0)}
                    />{' '}
                    <span>Sun</span>
                  </div>
                  <div className={'form-control-checkbox-span'}>
                    <input
                      type="checkbox"
                      checked={notification_settings.notify_users_to_fill_the_form_sending_week_days?.includes(1)}
                      onChange={(e) => handleSelectWeekDays(1)}
                    />{' '}
                    <span>Mon</span>
                  </div>
                  <div className={'form-control-checkbox-span'}>
                    <input
                      type="checkbox"
                      checked={notification_settings.notify_users_to_fill_the_form_sending_week_days?.includes(2)}
                      onChange={(e) => handleSelectWeekDays(2)}
                    />{' '}
                    <span>Tue</span>
                  </div>
                  <div className={'form-control-checkbox-span'}>
                    <input
                      type="checkbox"
                      checked={notification_settings.notify_users_to_fill_the_form_sending_week_days?.includes(3)}
                      onChange={(e) => handleSelectWeekDays(3)}
                    />{' '}
                    <span>Wed</span>
                  </div>
                  <div className={'form-control-checkbox-span'}>
                    <input
                      type="checkbox"
                      checked={notification_settings.notify_users_to_fill_the_form_sending_week_days?.includes(4)}
                      onChange={(e) => handleSelectWeekDays(4)}
                    />{' '}
                    <span>Thu</span>
                  </div>
                  <div className={'form-control-checkbox-span'}>
                    <input
                      type="checkbox"
                      checked={notification_settings.notify_users_to_fill_the_form_sending_week_days?.includes(5)}
                      onChange={(e) => handleSelectWeekDays(5)}
                    />{' '}
                    <span>Fri</span>
                  </div>
                  <div className={'form-control-checkbox-span'}>
                    <input
                      type="checkbox"
                      checked={notification_settings.notify_users_to_fill_the_form_sending_week_days?.includes(6)}
                      onChange={(e) => handleSelectWeekDays(6)}
                    />{' '}
                    <span>Sat</span>
                  </div>
                </div>
                <span className="form-error">
                  {errors?.notify_users_to_fill_the_form_sending_week_days && errors.notify_users_to_fill_the_form_sending_week_days[0]}
                </span>
              </div>
            )}

            {notification_settings.notify_users_to_fill_the_form_period?.value == 'monthly' && (
              <div className={'form-item multi-date-picker disabled-change-month mb-6'}>
                <label className="form-label">Send on days</label>
                <div className={'clear-datepicker'}>
                  <MultiDatePicker
                    multiple
                    format={'DD'}
                    editable={false}
                    placeholder={'Choose Days'}
                    currentDate={
                      new DateObject({
                        year: 2024,
                        month: 12,
                        day: 1,
                      })
                    }
                    value={notification_settings.notify_users_to_fill_the_form_sending_month_days}
                    onChange={(dates) => {
                      handelSettings(
                        dates.map((value) => value),
                        'notify_users_to_fill_the_form_sending_month_days',
                      );
                    }}
                  />
                  {notification_settings.notify_users_to_fill_the_form_sending_month_days?.length > 0 && (
                    <button onClick={() => handelSettings([], 'notify_users_to_fill_the_form_sending_month_days')} className={'clear'}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <g clipPath="url(#clip0_5205_22763)">
                          <path
                            d="M12.5001 7.5013L7.50008 12.5013M7.50008 7.5013L12.5001 12.5013M18.3334 10.0013C18.3334 14.6037 14.6025 18.3346 10.0001 18.3346C5.39771 18.3346 1.66675 14.6037 1.66675 10.0013C1.66675 5.39893 5.39771 1.66797 10.0001 1.66797C14.6025 1.66797 18.3334 5.39893 18.3334 10.0013Z"
                            stroke="#D92D20"
                            strokeWidth="1.67"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_5205_22763">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </button>
                  )}
                </div>
                <span className="form-error">
                  {errors?.notify_users_to_fill_the_form_sending_month_days && errors.notify_users_to_fill_the_form_sending_month_days[0]}
                </span>
              </div>
            )}

            <div className="form-control-item-group form-item-time">
              <label className="form-label">Time</label>
              <Select
                hideSelectedOptions={false}
                isSearchable={false}
                options={timeOptions}
                value={notification_settings.notify_users_to_fill_the_form_sending_time}
                onChange={(e) => handelSettings(e, 'notify_users_to_fill_the_form_sending_time')}
                className="form-control-select"
                // The settings column scrolls, so the menu has to leave it to be able to
                // flip above the field instead of being cut off at the bottom.
                menuPortalTarget={document.body}
                menuPlacement="auto"
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  // The default radius assumes the menu hangs below the field.
                  menu: (base, state) => (state.placement === 'top' ? { ...base, borderRadius: '6px 6px 0 0' } : base),
                }}
                placeholder="Period"
                classNamePrefix="react-select"
              ></Select>
              <span className="form-error">
                {errors?.notify_users_to_fill_the_form_sending_time && errors.notify_users_to_fill_the_form_sending_time[0]}
              </span>
            </div>

            <div className="form-control-item-group">
              <label className="form-label">When notifications should stop being sent</label>
              <Select
                hideSelectedOptions={false}
                isSearchable={false}
                options={NotifyUsersToFillTheFormStopType}
                value={notification_settings.notify_users_to_fill_the_form_stop_type}
                onChange={(e) => handelSettings(e, 'notify_users_to_fill_the_form_stop_type')}
                className="form-control-select"
                menuPlacement="auto"
                placeholder="Choose"
                classNamePrefix="react-select"
              ></Select>
              <span className="form-error">
                {errors?.notify_users_to_fill_the_form_stop_type && errors.notify_users_to_fill_the_form_stop_type[0]}
              </span>
            </div>

            {notification_settings.notify_users_to_fill_the_form_stop_type?.value === 'specific_date' && (
              <div className="form-control-item-group">
                <label className="form-label">Date</label>
                <DateCalendar
                  selectedDate={notification_settings.notify_users_to_fill_the_form_stop_date}
                  handleChange={(date) => handelSettings(date, 'notify_users_to_fill_the_form_stop_date')}
                  isClearable
                  placeholderText="Choose Date"
                />
                <span className="form-error">
                  {errors?.notify_users_to_fill_the_form_stop_date && errors.notify_users_to_fill_the_form_stop_date[0]}
                </span>
              </div>
            )}

            {notification_settings.notify_users_to_fill_the_form_stop_type?.value === 'interval' && (
              <div className="form-control-item-group">
                <label className="form-label">Choose period</label>
                <div className="d-flex gap-3">
                  <div className="form-control-item-half">
                    <Select
                      hideSelectedOptions={false}
                      isSearchable={false}
                      menuPlacement="top"
                      options={NotifyUsersToFillTheFormStopPeriod}
                      value={notification_settings.notify_users_to_fill_the_form_stop_period}
                      onChange={(e) => handelSettings(e, 'notify_users_to_fill_the_form_stop_period')}
                      className="form-control-select"
                      placeholder="Select"
                      classNamePrefix="react-select"
                    ></Select>
                    <span className="form-error">
                      {errors?.notify_users_to_fill_the_form_stop_period && errors.notify_users_to_fill_the_form_stop_period[0]}
                    </span>
                  </div>

                  <div className="form-control-item-half">
                    <Select
                      hideSelectedOptions={false}
                      isSearchable={false}
                      menuPlacement="top"
                      options={NotifyUsersToFillTheFormStopFrequency}
                      value={notification_settings.notify_users_to_fill_the_form_stop_frequency}
                      onChange={(e) => handelSettings(e, 'notify_users_to_fill_the_form_stop_frequency')}
                      className="form-control-select"
                      placeholder="Period"
                      classNamePrefix="react-select"
                    ></Select>
                    <span className="form-error">
                      {errors?.notify_users_to_fill_the_form_stop_frequency && errors.notify_users_to_fill_the_form_stop_frequency[0]}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default NotifyUsersSettings;
